<h2>Add note</h2>
<p class="stage-info">You are changing the stage. Please provide details for this change.</p>

<form [formGroup]="stageChangeNoteFormGroup">
    <div class="row">
        <mat-form-field class="col-12" appearance="outline">
            <mat-label>Note subject</mat-label>
            <mat-select formControlName="subject">
                <mat-option *ngFor="let subject of noteSubjects" [value]="subject.subject">
                    {{ subject.subject }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="stageChangeNoteFormGroup.get('subject')?.hasError('required')">
                Note subject is required
            </mat-error>
        </mat-form-field>
    </div>

    <div class="row">
        <mat-form-field class="col-12" appearance="outline">
            <mat-label>Description</mat-label>
            <input formControlName="description" matInput maxlength="250"/>
            <mat-hint align="end">{{ stageChangeNoteFormGroup.get('description')?.value?.length || 0 }}/250</mat-hint>
        </mat-form-field>
    </div>

    <div class="row">
        <mat-form-field class="col-12" appearance="outline">
            <mat-label>Remark</mat-label>
            <textarea
                    formControlName="note"
                    matInput
                    placeholder="Remark for this stage change"
                    rows="4"></textarea>
        </mat-form-field>
    </div>

    <div class="row">
        <div class="col" style="display: flex; flex-direction: row; gap: 0.7em">
            <button
                    (click)="onSubmit()"
                    [disabled]="stageChangeNoteFormGroup.invalid || isLoadingSubjects"
                    color="primary"
                    mat-raised-button>
                Save
            </button>
            <button (click)="bottomSheetRef.dismiss()" color="primary" mat-button>Cancel</button>
        </div>
    </div>
</form>